import { configureStore } from '@reduxjs/toolkit';
import shipmentFormReducer from './shipmentFormSlice';

export const store = configureStore({
  reducer: {
    shipmentForm: shipmentFormReducer,
  },
  // Enable Redux DevTools in development
  devTools: process.env.NODE_ENV !== 'production',
});

// Expose store on window for debugging in development
if (process.env.NODE_ENV === 'development') {
  window.store = store;
}

export default store;
